import { useGetMyPipelineBySalesStageDashletQuery, useGetOpportunitiesByLeadSourceByOutcomeDashletsQuery, useGetOpportunitiesByLeadSourceDashletsQuery, useGetOutcomeByMonthDashletQuery, useGetPipelineBySalesStageDashletQuery, } from "@/store/api";
export var useChartsData = function () {
    var opportunitiesByLeadSourceDashlets = useGetOpportunitiesByLeadSourceDashletsQuery({});
    var opportunitiesByLeadSourceByOutcomeDashlets = useGetOpportunitiesByLeadSourceByOutcomeDashletsQuery({});
    var pipelineBySalesDashlets = useGetPipelineBySalesStageDashletQuery({});
    var outcomeByMonthDashlets = useGetOutcomeByMonthDashletQuery({});
    var myPipelineBySalesStageDashlet = useGetMyPipelineBySalesStageDashletQuery({});
    return {
        opportunitiesByLeadSourceDashlets: opportunitiesByLeadSourceDashlets,
        opportunitiesByLeadSourceByOutcomeDashlets: opportunitiesByLeadSourceByOutcomeDashlets,
        pipelineBySalesDashlets: pipelineBySalesDashlets,
        outcomeByMonthDashlets: outcomeByMonthDashlets,
        myPipelineBySalesStageDashlet: myPipelineBySalesStageDashlet,
    };
};
